import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromEventTicketPackages from './+state/event-ticket-packages.reducer'
import { EventTicketPackagesEffects } from './+state/event-ticket-packages.effects'
import { EventTicketPackagesFacade } from './+state/event-ticket-packages.facade'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromEventTicketPackages.EVENT_TICKET_PACKAGES_FEATURE_KEY, fromEventTicketPackages.reducer),
    EffectsModule.forFeature([EventTicketPackagesEffects]),
  ],
  providers: [EventTicketPackagesFacade],
})
export class GbDashboardEventTicketsDataAccessEventTicketPackagesModule {}
